<ce-container class="EventLogResult u-spacing-2xl-pt">
    <header class="EventLogResult-header u-spacing-xl-mb">
        <a ce-link-button [routerLink]="['/logs']" class="EventLogResult-back">
            <ce-icon [svgIcon]="'arrow-left'" prefix-icon />
            <span>Back to lookup</span>
        </a>

        <h2 class="EventLogResult-title u-text-title-lg u-color-text-primary u-spacing-sm-mt u-spacing-xs-mb">
            Event log
        </h2>
        <p class="EventLogResult-charger u-text-body-md u-color-text-secondary">
            Charger identifier: <strong>{{ chargerId() }}</strong>
        </p>
    </header>

    @if (showLoading()) {
        <div class="EventLogResult-loading flex flex-center u-spacing-2xl-pa" data-testid="event-log-loading">
            <ce-spinning-loader />
        </div>
    }

    @if (hasResults()) {
        <div class="EventLogResult-actions u-spacing-md-mb">
            <button
                ce-button
                ce-button-type-tertiary
                [disabled]="pdfDownloading()"
                (click)="downloadPdf()"
                data-testid="download-pdf"
            >
                <ce-icon [svgIcon]="'download'" prefix-icon />
                <span>{{ pdfDownloading() ? 'Preparing…' : 'Download PDF' }}</span>
            </button>
        </div>

        <ce-action-table class="EventLogResult-table" [tableData]="tableData()" data-testid="event-log-table" />
    }

    @if (showEmpty()) {
        <ce-empty-state type="not-found" icon="search" data-testid="event-log-empty">
            <h2 ce-empty-state-title>No event log found</h2>
            <p ce-empty-state-description>
                No CTEP event log is available for charger
                <strong>{{ chargerId() }}</strong
                >. Check the identifier and try again.
            </p>
            <a ce-link-button [routerLink]="['/logs']">Try another charger</a>
        </ce-empty-state>
    }

    @if (showError()) {
        <ce-empty-state type="error-xs" icon="urgent" data-testid="event-log-error">
            <h2 ce-empty-state-title>Could not load event log</h2>
            <p ce-empty-state-description>{{ errorMessage() }}</p>
            <a ce-link-button [routerLink]="['/logs']">Try another charger</a>
        </ce-empty-state>
    }
</ce-container>
